import React from 'react';
import { Box } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

const SellingMonths = ({ selling_months, title }) => {

	// Validar dados antes de renderizar
	if (!selling_months || !Array.isArray(selling_months) || selling_months.length === 0) {
		return (
			<>
				<h5 className='title' align='left'>
					{title}
				</h5>
				<Box m={2} />
				<p>Nenhum dado disponível</p>
			</>
		);
	}

	// Garantir que todos os valores são strings válidas
	const validMonths = selling_months.filter(
		(month) => month && month.selling_month && typeof month.selling_month === 'string'
	);

	if (validMonths.length === 0) {
		return (
			<>
				<h5 className='title' align='left'>
					{title}
				</h5>
				<Box m={2} />
				<p>Nenhum dado válido disponível</p>
			</>
		);
	}

	const data = {
		labels: validMonths.map((month) => month.selling_month),
		datasets: [
			{
				data: validMonths.map((month) => month.share || 0),
				backgroundColor: '#d0315e',
			},
		],
	};

	const options = {
		indexAxis: 'y',
		legend: {
			display: false,
		},
		scales: {
			x: {
				ticks: {
					beginAtZero: true,
					callback: function (value, index, values) {
						return value + '%';
					},
				},
			},
			y: {
				ticks: {
					beginAtZero: true,
					callback: function (value, index, values) {
						// Validar que value é uma string antes de usar split
						if (typeof value !== 'string' || !value.includes('-')) {
							return value;
						}
						try {
							const [year, month] = value.split('-');
							if (year && month) {
								return moment(`${year}-${month}-01`).format('MM/YYYY');
							}
							return value;
						} catch (error) {
							return value;
						}
					},
				},
			},
		},
		plugins: {
			tooltip: {
				callbacks: {
					title: function (tooltipItem) {
						const value = tooltipItem[0].label;
						// Validar que value é uma string antes de usar split
						if (typeof value !== 'string' || !value.includes('-')) {
							return value;
						}
						try {
							const [year, month] = value.split('-');
							if (year && month) {
								return moment(`${year}-${month}-01`).format('MM/YYYY');
							}
							return value;
						} catch (error) {
							return value;
						}
					},
					label: function (context) {
						const value = context.parsed.x;
						return value + '%';
					},
				},
			},
		},
	};

	// Gerar uma key única baseada nos dados para forçar recriação do gráfico
	const chartKey = validMonths.map(m => m.selling_month).join('-');

	return (
		<>
			<h5 className='title' align='left'>
				{title}
			</h5>
			<Box m={2} />
			<Bar key={chartKey} data={data} options={options} />
		</>
	);
};

export default SellingMonths;
